import React from 'react';
import {Map, List} from 'immutable';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins, withSystem, Atom} from '@packages/systems/wfdl';
import {TRecord, TText} from '@packages/systems/wfdl-ast';
import {checkoutInputStyle, mobileCheckoutInputStyle} from './styles';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const StreetAddressInputOptional = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    return (
      <input
        {...generateAttributes(attributes, classes)}
        name="address_line2"
        type="text"
      />
    );
  }
);

const staticBindings = Map({
  value: List([
    Map({
      slug: 'billingAddressLine2',
      type: 'PlainText',
    }),
  ]),
});

const config = createIntegratedAtom({
  displayName: 'Street Address 2',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  showEmpty: false,
  render: StreetAddressInputOptional,
  style: {
    base: {
      main: checkoutInputStyle,
      tiny: mobileCheckoutInputStyle,
    },
  },
  staticBindings,
  fields: {
    attr: withSystem(
      {private: true},
      TRecord({
        'aria-label': TText,
      })
    ),
  },
});

export default config;
